"use strict";
// DO NOT EDIT. Generated by gitlab.com/accumulatenetwork/accumulate/tools/cmd/gen-types.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainType = void 0;
/* eslint-disable @typescript-eslint/no-namespace */
var ChainType;
(function (ChainType) {
    /** Unknown is used when the chain type is not known. */
    ChainType[ChainType["Unknown"] = 0] = "Unknown";
    /** Transaction holds transaction hashes. */
    ChainType[ChainType["Transaction"] = 1] = "Transaction";
    /** Anchor holds chain anchors. */
    ChainType[ChainType["Anchor"] = 2] = "Anchor";
    /** Index indexes other chains. */
    ChainType[ChainType["Index"] = 4] = "Index";
})(ChainType = exports.ChainType || (exports.ChainType = {}));
/** @ignore */
(function (ChainType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    ChainType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "unknown":
                return ChainType.Unknown;
            case "transaction":
                return ChainType.Transaction;
            case "anchor":
                return ChainType.Anchor;
            case "index":
                return ChainType.Index;
            default:
                throw new Error(`Unknown ChainType '${name}'`);
        }
    }
    ChainType.byName = byName;
    function getName(v) {
        switch (v) {
            case ChainType.Unknown:
                return "unknown";
            case ChainType.Transaction:
                return "transaction";
            case ChainType.Anchor:
                return "anchor";
            case ChainType.Index:
                return "index";
            default:
                throw new Error(`Unknown ChainType ${v}`);
        }
    }
    ChainType.getName = getName;
})(ChainType = exports.ChainType || (exports.ChainType = {}));
//# sourceMappingURL=enums_gen.js.map